module.exports = __webpack_public_path__ + "img/trip_15.66b0c10f.jpg";